export default __webpack_public_path__ + "static/media/ic_northern_cyprus.97d8b35e.svg";